import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { MdEmail, MdClose } from "react-icons/md";
import Swal from "sweetalert2";
import { contactInquiry } from "../../../Services/APIrequests";
import styles from "./BusinessesforSale.module.css";
import Footer from "../Footer/Footer";
import Nav from "../Nav/Nav";
import useStore from "../../../Store";

const BusinessescontactForm = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const direction = useStore((state) => state.direction);
    const navigate = useNavigate();
    const { CIN } = useParams();
    const [loading, setLoading] = React.useState(false);

    const validateName = (value) =>
        /^[A-Za-z\s]+$/.test(value) ||
        "Full Name can only contain letters and spaces.";

    const validatePhoneNumber = (value) =>
        /^\d+$/.test(value) || "Phone Number can only contain numbers.";

    const validateBusinessName = (value) =>
        !value ||
        /^[A-Za-z\s]+$/.test(value) ||
        "Business Name can only contain letters and spaces.";

    const onSubmit = async (data) => {
        setLoading(true);
        const body = {
            name: data.fullName,
            phoneNumber: data.phoneNumber,
            description: data.businessDescription,
            email: data.email,
            location: data.location,
            CIN: CIN,
            ...(data.businessName && { companyName: data.businessName }),
        };

        try {
            const response = await contactInquiry(body);
            if (response.data.success) {
                // Show success modal and navigate back when confirmed
                const storedCompanyName =
                    sessionStorage.getItem("companyName") || "Company";
                await Swal.fire({
                    icon: "success",
                    title: "Contact request sent",
                    html: `<strong>${storedCompanyName}</strong> will contact you soon.`,
                    confirmButtonText: "Back",
                });
                navigate(-1);
            } else {
                alert(response.data.message || "Something went wrong");
            }
        } catch (error) {
            console.error("Error submitting contact inquiry:", error);
            alert("Something went wrong while submitting the inquiry.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ direction }}>
            <Nav />
            <div className={styles.contanct_sale_formWrapper}>
                <div className={styles.formWrapper}>
                    <div className={styles.header}>
                        <h2>
                            <MdEmail className={styles.icon} /> Contact Business
                        </h2>
                        <MdClose
                            className={styles.closeIcon}
                            onClick={() => navigate(-1)}
                        />
                    </div>
                    <p className={styles.subText}>One Time Registration</p>

                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        className={styles.form}>
                        {/* Full Name */}
                        <div className={styles.formGroup}>
                            <label>Full Name</label>
                            <input
                                type="text"
                                placeholder="Enter your full name"
                                {...register("fullName", {
                                    required: "Full Name is required",
                                    validate: validateName,
                                })}
                            />
                            {errors.fullName && (
                                <p className={styles.error}>
                                    {errors.fullName.message}
                                </p>
                            )}
                        </div>

                        {/* Phone Number */}
                        <div className={styles.formGroup}>
                            <label>Phone Number</label>
                            <input
                                type="tel"
                                placeholder="Enter your phone number"
                                {...register("phoneNumber", {
                                    required: "Phone Number is required",
                                    validate: validatePhoneNumber,
                                })}
                            />
                            {errors.phoneNumber && (
                                <p className={styles.error}>
                                    {errors.phoneNumber.message}
                                </p>
                            )}
                        </div>

                        {/* Business Name */}
                        <div className={styles.formGroup}>
                            <label>Business Name (optional)</label>
                            <input
                                type="text"
                                placeholder="Enter your business name"
                                {...register("businessName", {
                                    validate: validateBusinessName,
                                })}
                            />
                            {errors.businessName && (
                                <p className={styles.error}>
                                    {errors.businessName.message}
                                </p>
                            )}
                        </div>

                        {/* Description */}
                        <div className={styles.formGroupFull}>
                            <label>Description</label>
                            <textarea
                                placeholder="Provide a brief description of the business"
                                {...register("businessDescription", {
                                    required: "Description is required",
                                })}
                                rows="4"
                            />
                            {errors.businessDescription && (
                                <p className={styles.error}>
                                    {errors.businessDescription.message}
                                </p>
                            )}
                        </div>

                        {/* Email */}
                        <div className={styles.formGroup}>
                            <label>Email</label>
                            <input
                                type="email"
                                placeholder="Enter your email address"
                                {...register("email", {
                                    required: "Email is required",
                                })}
                            />
                            {errors.email && (
                                <p className={styles.error}>
                                    {errors.email.message}
                                </p>
                            )}
                        </div>

                        {/* Location */}
                        <div className={styles.formGroup}>
                            <label>Location</label>
                            <input
                                type="text"
                                placeholder="Enter your location"
                                {...register("location", {
                                    required: "Location is required",
                                })}
                            />
                            {errors.location && (
                                <p className={styles.error}>
                                    {errors.location.message}
                                </p>
                            )}
                        </div>

                        {/* Submit */}
                        <button
                            type="submit"
                            className={styles.submitBtn}
                            disabled={loading}>
                            {loading ? "Submitting..." : "Continue"}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default BusinessescontactForm;
